// extracted by mini-css-extract-plugin
export default {"footer":"footer__DGBa9","button":"button__54Ddy","contact":"contact__k-kf0","dropdown":"dropdown__IMh-3","leave":"leave__neUTO","header":"header__8cefX"};